module.exports = __webpack_public_path__ + "img/Budget-Category.7d3b205c.jpg";